module.exports = __webpack_public_path__ + "static/media/weis.d0e3ca8a.jpg";